import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getEntity, deleteEntity } from './cons-family-document-type.reducer';

export const ConsFamilyDocumentTypeDeleteDialog = (props: RouteComponentProps<{ id: string }>) => {
  const [loadModal, setLoadModal] = useState(false);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
    setLoadModal(true);
  }, []);

  const consFamilyDocumentTypeEntity = useAppSelector(state => state.consFamilyDocumentType.entity);
  const updateSuccess = useAppSelector(state => state.consFamilyDocumentType.updateSuccess);

  const handleClose = () => {
    props.history.push('/cons-family-document-type');
  };

  useEffect(() => {
    if (updateSuccess && loadModal) {
      handleClose();
      setLoadModal(false);
    }
  }, [updateSuccess]);

  const confirmDelete = () => {
    dispatch(deleteEntity(consFamilyDocumentTypeEntity.id));
  };

  return (
    <Modal isOpen toggle={handleClose}>
      <ModalHeader toggle={handleClose} data-cy="consFamilyDocumentTypeDeleteDialogHeading">
        <Translate contentKey="entity.delete.title">Confirm delete operation</Translate>
      </ModalHeader>
      <ModalBody id="almobadaraMasterDataApp.consFamilyDocumentType.delete.question">
        <Translate
          contentKey="almobadaraMasterDataApp.consFamilyDocumentType.delete.question"
          interpolate={{ id: consFamilyDocumentTypeEntity.id }}
        >
          Are you sure you want to delete this ConsFamilyDocumentType?
        </Translate>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={handleClose}>
          <FontAwesomeIcon icon="ban" />
          &nbsp;
          <Translate contentKey="entity.action.cancel">Cancel</Translate>
        </Button>
        <Button id="jhi-confirm-delete-consFamilyDocumentType" data-cy="entityConfirmDeleteButton" color="danger" onClick={confirmDelete}>
          <FontAwesomeIcon icon="trash" />
          &nbsp;
          <Translate contentKey="entity.action.delete">Archive</Translate>
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ConsFamilyDocumentTypeDeleteDialog;
